<template>
    <div id="message-list" class="message-list ht-scroll-vertical" ref="messageList">
        <NameCard :uuid="uuid" v-if="uuid"/>
        <form action="javascript:void(0)" v-if="!uuid">
            <van-search
                    background="#f5f5f5"
                    v-model="keyword"
                    placeholder="请输入搜索关键词"
                    @search="debounceOnSearch"
                    :clearable="false"
            />
        </form>

        <van-list
            v-if="!showEmpty"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
        >
            <MessageItem v-for="(item,index) in list" :key="index" :item="item" :showUserLink="!isFlag" @refreshMessageList="refreshMessageList"/>
        </van-list>
        <div class="empty-container" v-else>
            <Error type="empty"/>
        </div>
    </div>
</template>

<script>
import {Cell, List, Search, Toast} from 'vant'
import {debounce} from 'lodash-es'
import {queryInteractions, queryMessage} from "@/api/home"
import MessageItem from "@/components/Message/MessageItem"
import NameCard from "@/components/NameCard/NameCard"

export default {
        name: 'MessageList',
        components: {
            [List.name]: List,
            [Cell.name]: Cell,
            [Search.name]: Search,
            MessageItem,
            NameCard
        },
        props: ['uid', 'uuid'],
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                error: false,
                pageIndex: 0,
                totalPage: 0,
                userId: null,
                userUUID: null,
                keyword: '',
                showEmpty:false,
                isFlag:null
            }
        },
        computed: {},
        created() {
            this.userId = this.uid
            this.userUUID = this.uuid
            this.mixinShowLoading()
            this.debounceOnSearch = debounce(this.onSearch, 100)

        },
        beforeRouteUpdate(to, from, next) {
            this.userId = to.params.uid
            this.userUUID = to.params.uuid
            this.$refs.messageList.scrollTop = 0
            this.list = []
            this.pageIndex = 0
            this.loading = true
            this.finished = false
            this.onLoad()
            this.mixinShowLoading()
            next()
        },
        methods: {
            onLoad() {
                this.error = false
                const userId = this.userId
                if (userId) {
		        	this.isFlag = false;
		      	} else {
		        	this.isFlag = true;
		      	}
                let promise = userId ? queryInteractions(this.pageIndex, userId) : queryMessage(this.pageIndex, this.keyword)
                promise.then(resp => {
                    //if (userId != this.userId) return;
                    if (resp.data.length==0) {
                        this.emptyShow = true;
                        this.finished = true;
                        return;
                    }
                    this.list = this.list.concat(resp.data)
                    console.log('this.list: ', this.list);
                    if (this.list.length >= resp.total) this.finished = true
                    this.totalPage = resp.totalPage;
                    if (this.pageIndex >= this.totalPage) {
                      this.finished = true;
                    } else {
                      this.pageIndex++;
                    }
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                    Toast.fail('服务器繁忙或网络异常，请稍后重试')
                }).finally(() => {
                    this.mixinClearLoading()
                })
            },
            onSearch() {
                this.$refs.messageList.scrollTop = 0
                this.list = []
                this.pageIndex = 0
                this.loading = true
                this.finished = false
                this.onLoad()
                this.mixinShowLoading()
            },
            //刷新消息列表
            refreshMessageList() {
                queryMessage(0, this.keyword).then(resp => {
                    this.list = resp.data
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .message-list {
        height: 100vh;
    }
</style>
<style>
.message-list input::placeholder{
  color: #666666!important;
}
</style>
